import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import CardTr from './CardTr';

import './Ship.css'
import ImageModal from '../common/Modal/ImageModal'
import ShipDetailModal from './Modal/ShipDetailModal'
import { useTranslation } from "react-i18next";
import { fetchShipment } from '../../../utils/apiClient';

const ShipDetail = ({}) => {
  const { t } = useTranslation();

  const { shop, id } = useParams()

  const [shipInfo, setShipInfo] = useState({})
  const [cardList, setcardList] = useState([])
  const [isRestricted, setIsRestricted] = useState(false) // WAF制限状態

  const [modalImageIsOpen, setModalImageIsOpen] = useState([false, '']);

  const openImageModal = (e) => {
    setModalImageIsOpen([true, e.target.src]);
  }

  const closeImageModal = () => {
    setModalImageIsOpen([false, '']);
  }

  const [cardSetting, changeCardSetting] = useState(true);

  const showCardSettingHandler = () => {
    changeCardSetting(true);
  }

  const hideCardSettingHandler = () => {
    changeCardSetting(false);
  }

  const CreateCardList = () => {
    return cardList.map((card) => {
      return <CardTr card={card} openImageModal={openImageModal} confirmPackage={true} key={"ship"+card.id}/>
    })
  }

  const userId = (id) => {
    if(id === null || id === undefined) return '';
    return id;
  };
  
  useEffect(() => {
    const loadShipmentDetail = async () => {
      try {
        const response = await fetchShipment(id);
        const responseData = await response.json();
        
        // 新しいレスポンス形式に対応
        if (responseData.data) {
          // 新しい形式（data + meta構造）
          setShipInfo(responseData.data);
          setcardList(responseData.data.shipment_cards || []);
          setIsRestricted(responseData.meta?.personal_info_restricted || false);
          
          // WAF制限状態のメッセージ表示
          if (responseData.meta?.personal_info_restricted) {
            console.log('個人情報が制限されています（WAFブロック対応）:', responseData.meta?.message);
          }
        } else {
          // 従来の形式（後方互換性）
          setShipInfo(responseData);
          setcardList(responseData.shipment_cards || []);
          setIsRestricted(responseData._isRestricted || false);
          
          // WAF制限状態を表示（デバッグ用）
          if (responseData._isRestricted) {
            console.log('個人情報が制限されています（WAFブロック対応）');
          }
        }
      } catch (error) {
        console.error('配送詳細の取得に失敗しました:', error);
        alert(t('common.error'));
      }
    };

    loadShipmentDetail();
  }, [])
  
  const [statusChangeModalIsOpen, setStatusChangeModalIsOpen] = useState(false)

  const statusChangeHandler = (e) => {
    setStatusChangeModalIsOpen(true)
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="ship-detail">
        <div className="ship-detail-content">
          <div className="ship-detail-title">{t('ship_detail.title')}</div>
          <div className='clearfix'></div>
          <div className="ship-detail-back">
            <Link to={`/${shop}/ship`}>
              <button className="ship-detail-back-button">{t('ship_detail.back')}</button>
            </Link>
          </div>
          <div className="ship-detail-edit">
            <button className="ship-detail-edit-button" onClick={statusChangeHandler}>{t('ship_detail.edit')}</button>
          </div>
          <div className='clearfix'></div>
          <dl className="ship-detail-info-confirm ship-detail-info-confirm">
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.id')}</dt>
            <dd className="ship-detail-info-confirm-text">{shipInfo.id}</dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.day')}</dt>
            <dd className="ship-detail-info-confirm-text">{shipInfo.order_date}</dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.user_id')}</dt>
            <dd className="ship-detail-info-confirm-text">{userId(shipInfo.user_id)}</dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.client')}</dt>
            <dd className="ship-detail-info-confirm-text">{isRestricted ? '***' : shipInfo.client_name}</dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.country')}</dt>
            <dd className="ship-detail-info-confirm-text">{shipInfo.client_address && shipInfo.client_address['country']}</dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.ship')}</dt>
            <dd className="ship-detail-info-confirm-text">
            {(() => {
                if (isRestricted || shipInfo.client_address === '***') {
                    return '〒***-*** ***';
                }

                const postalCode = shipInfo.client_address?.postal_code || '';
                const addr = shipInfo.client_address?.address || '';
                const addr2 = shipInfo.client_address?.address2 || '';
                const fullAddress = addr2 ? `${addr} ${addr2}` : addr;

                // 郵便番号が無くても住所は表示する（郵便番号のみ欠落しても住所を隠さない）
                const zip = postalCode
                    ? (postalCode.substr(3)[0] === '-'
                        ? `〒${postalCode} `
                        : `〒${postalCode.substr(0,3)}-${postalCode.substr(3)} `)
                    : '';

                return `${zip}${fullAddress}`.trim() || '-';
            })()} 
            </dd>
            <dt className="ship-detail-info-confirm-title">{t('ship_detail.phone_number')}</dt>
            <dd className="ship-detail-info-confirm-text">{isRestricted ? '***' : (shipInfo.client_address && shipInfo.client_address['phone_number'])}</dd>
            <dt className="ship-detail-info-confirm-title clear-left">{t('ship_detail.raw_address')}</dt>
            <dd className="ship-detail-info-confirm-text">
            {(() => {
                if (isRestricted || shipInfo.client_address === '***') {
                    return '***';
                }
                if (shipInfo.client_address === undefined || shipInfo.client_address === null) {
                    return '-';
                }
                return <pre className="ship-detail-info-confirm-raw">{JSON.stringify(shipInfo.client_address, null, 2)}</pre>;
            })()}
            </dd>
            <dt className="ship-detail-info-confirm-title clear-left">{t('ship_detail.status')}</dt>
            <dd className="ship-detail-info-confirm-text"><div className={`ship-status-${shipInfo.status}`}>{[t('ship_detail.status1'), t('ship_detail.status2'), t('ship_detail.status3'), t('ship_detail.status4'), t('ship_detail.status5'), t('ship_detail.status6'), t('ship_detail.status7')][shipInfo.status-1]}</div></dd>

          </dl>
          <div className='clearfix'></div>
          <div className="ship-detail-info-sub-title">{t('ship_detail.card')}</div>
            {!cardSetting ? 
              <>
                <button className="ship-detail-info-close-button" onClick={showCardSettingHandler}>{t('ship_detail.open')}</button>
                <div className='clearfix'></div>
                <div className='line2'></div>
              </>
              :
              <>
                <button className="ship-detail-info-close-button" onClick={hideCardSettingHandler}>{t('ship_detail.close')}</button>
                <div className='clearfix'></div>
                <div className='line2'></div>
                <div className="ship-detail-content-table">
                  <table className="ship-detail-content-table">
                    <thead>
                      <tr>
                        <th>{t('ship_detail.image')}</th>
                        <th>{t('ship_detail.package')}</th>
                        <th>{t('ship_detail.name')}</th>
                        <th>{t('ship_detail.rank')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <CreateCardList />
                    </tbody>
                  </table>
                </div>
              </>
            }
          </div>
        </div>
        {modalImageIsOpen[0] && 
        <ImageModal
          modalIsOpen={modalImageIsOpen}
          closeModal={closeImageModal}
          link={modalImageIsOpen[1]}
          customClass='ship-detail-info-card-image-modal'
        />
        }
      <ShipDetailModal statusChangeModalIsOpen={statusChangeModalIsOpen} setStatusChangeModalIsOpen={setStatusChangeModalIsOpen} shipInfo={shipInfo} setShipInfo={setShipInfo}/>
    </>
  )
}

export default ShipDetail